import { Button, IPropsButton } from '../Button';

interface IProps extends IPropsButton {
  handleClickButton?: any;
}

export function ModalButton({ handleClickButton, ...props }: IProps) {
  return <Button onClick={handleClickButton} {...props} />;
}
